import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Tooltip } from 'reactstrap';

export interface IIconWithTooltipProps {
    name: string;
    icon: IconDefinition;
    tooltipText: string;
    iconClassName?: string;
    className?: string;
}

const IconWithTooltip = ({
    name, className, icon, iconClassName, tooltipText,
}: IIconWithTooltipProps) => {
    const [openTooltip, setOpenTooltip] = useState(false);

    const toggleTooltip = () => {
        setOpenTooltip(!openTooltip);
    };

    return (
        <div className={className}>
            <FontAwesomeIcon
                id={`${name}-tooltip`}
                icon={icon}
                className={iconClassName}
            />
            <Tooltip
                target={`${name}-tooltip`}
                isOpen={openTooltip}
                toggle={toggleTooltip}
                placement="top"
            >
                <div>{tooltipText}</div>
            </Tooltip>
        </div>
    );
};

export default IconWithTooltip;
